

import "./hrmsBusiness.css";
import shape from "../../assets/service/shape.png";
import techcognics from "../../assets/techcognics_logo.png";
import { Helmet } from "react-helmet";


const HrmsBusiness = () => {
    return (
        <>
            <Helmet>
                <title>
                    HR Software for a Successful & Growing Business | HRMS | TechCognics
                </title>

                <meta
                    name="description"
                    content="Drive business success with modern HR software. Automate payroll, attendance, compliance, and employee management using a scalable, cloud-based HRMS solution by TechCognics."
                />

                <meta
                    name="keywords"
                    content="HR software, HRMS software, HR software for business, HR management system, payroll HR software, employee management software, cloud HRMS, HR software India"
                />

                <meta
                    property="og:title"
                    content="HR Software for a Successful & Growing Business | TechCognics"
                />

                <meta
                    property="og:description"
                    content="Build a successful business with TechCognics HRMS software. Automate HR operations, payroll, attendance, and workforce management with a secure cloud platform."
                />

                <meta property="og:type" content="website" />
            </Helmet>
            <div class="why-choose-us__one py-4">
                <div class="container-fluid">
                    <div class="row  align-items-center">
                        {/* Heading */}
                        <div className="site-heading text-center ">
                            <div className="text-center feature-heading" style={{ color: '#0F4F93' }}>An HRMS Software for a Successful Business</div>

                        </div>
                        <section className="app-section">
                            <div class="container">
                                <div className="row align-items-center">
                                    {/* Logo */}
                                    <div className="col-lg-2 col-md-2 col-12 d-flex justify-content-center align-items-center mb-3 mb-md-0">
                                        <img
                                            src={techcognics}
                                            alt="Techcognics"
                                            className="erp-logo-landing-page img-fluid"
                                        />
                                    </div>


                                    {/* Content */}
                                    <div className="col-lg-10 col-md-10 col-12">
                                        <p className="erp-desc text-start">
                                            <strong>TechCognics</strong> delivers cloud-based HRMS solutions designed for growing businesses and enterprises. Our platform streamlines end-to-end HR processes, including recruitment, attendance, payroll, compliance, and performance management. Scalable and user-friendly, TechCognics HRMS improves workforce productivity with real-time insights and reliable support.
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </section>

                    </div>
                </div>
            </div>
        </>
    );
};

export default HrmsBusiness;

